import { fr } from "../../i18n/fr";
import { Field } from "../../ui/components";

/** Colours offered for a POI category, the colour picker allows any other one. */
export const PALETTE = ["#2f9e44", "#1971c2", "#e8590c", "#c92a2a", "#7048e8", "#0c8599", "#f08c00", "#495057"];
export const ICONS = Object.keys(fr.categories.icons);

export interface CategoryValues { name: string; color?: string; icon?: string; sortOrder?: number }

/** Name, colour, pictogram and order of a category: event categories and default categories (DR19). */
export function CategoryFields<T extends CategoryValues>({ value, onChange }: { value: T; onChange(v: NoInfer<T>): void }) {
  return (
    <>
      <Field label={fr.categories.name}><input value={value.name} onChange={(ev) => onChange({ ...value, name: ev.target.value })} required maxLength={60} autoFocus /></Field>
      <div className="grid2">
        <Field label={fr.categories.color}>
          <div className="row wrap">
            {PALETTE.map((c) => <button type="button" key={c} className={"swatch" + (value.color === c ? " active" : "")} style={{ background: c }} onClick={() => onChange({ ...value, color: c })} aria-label={c} />)}
            <input type="color" value={value.color || "#2f9e44"} onChange={(ev) => onChange({ ...value, color: ev.target.value })} />
          </div>
        </Field>
        <Field label={fr.categories.icon}>
          <select value={value.icon || "pin"} onChange={(ev) => onChange({ ...value, icon: ev.target.value })}>
            {ICONS.map((i) => <option key={i} value={i}>{fr.categories.icons[i]}</option>)}
          </select>
        </Field>
      </div>
      <Field label={fr.categories.order}><input type="number" min={0} value={value.sortOrder ?? 0} onChange={(ev) => onChange({ ...value, sortOrder: Number(ev.target.value) })} /></Field>
    </>
  );
}
